<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Transfer CashIn Method</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="cashInMethod"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row>
              <v-col cols="6">
                <custom-input name="name" label="CashIn Method Name" />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="payment_provider_id"
                  :items="providers"
                  @changed="updateTypes"
                  item-text="name"
                  item-value="id"
                  label="Provider"
                />
              </v-col>
              <v-col cols="6">
                <custom-select
                  name="payment_type_id"
                  :items="types"
                  item-text="name"
                  item-value="id"
                  label="Type"
                />
              </v-col>
              <v-col cols="6">
                <custom-input name="min_amount" type="number" label="Min Amount (€)" />
              </v-col>
              <v-col cols="6">
                <custom-input name="max_amount" type="number" label="Max Amount (€)" />
              </v-col>
              <v-col cols="6">
                <custom-select name="apps" :items="apps" label="Apps" multiple />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    cashInMethod: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      types: [],
      providers: [],
      cached_providers: [],
      apps: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    url() {
      if (this.cashInMethod && this.cashInMethod.id) {
        return `api/v1/transactions/transferCashInMethods/${this.cashInMethod.id}`;
      }
      return "api/v1/transactions/transferCashInMethods";
    },
  },
  watch: {
    isActive() {
      if (this.cashInMethod && typeof this.cashInMethod === "object") {
        const provider_id = this.cashInMethod.payment_provider_id;
        if (provider_id) {
          this.updateTypes(provider_id);
        }
      }
    },
  },
  methods: {
    fetchData() {
      this.getTransactionProviders();
      this.getTransactionApps();
    },
    getTransactionProviders() {
      return this.$http.get("/api/v1/transactions/transferPaymentProviders").then(({ data }) => {
        this.providers = data;
        this.cached_providers = data;
      });
    },
    getTransactionApps() {
      return this.$http.get("/api/v1/transactions/apps").then((data) => (this.apps = data));
    },
    updateTypes(payment_provider_id) {
      this.types = [];

      const provider = this.cached_providers.find((o) => o.id === payment_provider_id);

      if (provider && typeof provider === "object") {
        this.types = provider.payment_types;
      }
    },
  },
};
</script>
